import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import Helper from "util/Helper";

export class PlansUtils {
  constructor() {
    this.apiService = new APIService();
    this.helper = new Helper();
  }
  getAccountsById(id, onResponse, onError) {
    let url = APIConfig.myPlan.accountDashboard.getAccountById.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getTherapy(onResponse, onError) {
    let url = APIConfig.patient.therapyQuestions;
    return this.apiService.get(url, onResponse, onError);
  }
  getPlanByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.assignedPlans.getAssignedPlansByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }

  getFamilyRelations(onResponse, onError) {
    let url = APIConfig.familyPlan.getAllRelation;
    return this.apiService.get(url, onResponse, onError);
  }
  getDocumentTypeOptions(onResponse, onError) {
    let url = APIConfig.myPlan.plan.getDocumentTypeOptions;
    return this.apiService.get(url, onResponse, onError);
  }

  getPlansByFilter(id, onResponse, onError) {
    let url = APIConfig.familyPlan.getAllRelation;
    return this.apiService.get(url, onResponse, onError);
  }
  uploadImg = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.uploadContent;
    return this.apiService.postWithFormData(url, body, onResponse, onError);
  };
  createPlan = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.create;
    return this.apiService.post(url, body, onResponse, onError);
  };
  updatePlan = (body, id, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.update.format(id);
    return this.apiService.put(url, body, onResponse, onError);
  };
  renewPlan = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.renew;
    return this.apiService.post(url, body, onResponse, onError);
  };

  copyPlan = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.copyPlan;
    return this.apiService.post(url, body, onResponse, onError);
  };

  getAccountByCode = (code, onResponse, onError) => {
    let url = APIConfig.myPlan.accountDashboard.getAccountByCode.format(code);
    return this.apiService.get(url, onResponse, onError);
  };

  getAssignedServicesToPlanByFilter = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.getAssignedServicesToPlanByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  };
  getProviderOfPlanService = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.getProviderOfPlanService;
    return this.apiService.post(url, body, onResponse, onError);
  };
  getServicesByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.serviceDashboard.fetchServicesByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  createCustomisedServiceProvider = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.customiseServiceProvider;
    return this.apiService.post(url, body, onResponse, onError);
  };
  updateCustomisedServiceProvider = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.customiseServiceProvider;
    return this.apiService.put(url, body, onResponse, onError);
  };
  getAccountsByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.accountDashboard.getAccountsByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  whitelistUsersToPlanPhoneNo = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.whitelistUsersToPlanPhoneNo;
    return this.apiService.put(url, body, onResponse, onError);
  };
  whitelistUsersToPlanEmail = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.whitelistUsersToPlanEmail;
    return this.apiService.put(url, body, onResponse, onError);
  };

  fetchWhiteListedPhoneNumbersByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.plan.fetchWhiteListedPhoneNumbersByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  fetchWhiteListedEmailsByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.plan.fetchWhiteListedEmailsByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  deleteWhiteListedEmail(id, onResponse, onError) {
    let url = APIConfig.myPlan.plan.deleteWhiteListedEmail.format(id);
    return this.apiService.delete(url, onResponse, onError);
  }
  deleteWhiteListedPhoneNumber(id, onResponse, onError) {
    let url = APIConfig.myPlan.plan.deleteWhiteListedPhoneNumber.format(id);
    return this.apiService.delete(url, onResponse, onError);
  }
  fetchAssignedServiceToPlan(planId, serviceId, onResponse, onError) {
    let url = APIConfig.myPlan.assignedPlans.fetchAssignedServiceToPlan.format(
      planId,
      serviceId,
    );
    return this.apiService.get(url, onResponse, onError);
  }

  getL3CityMappingByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.plan.getL3CityMappingByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }

  updateCustomisedSPCityToPriceMapping(body, onResponse, onError) {
    let url = APIConfig.myPlan.plan.updateCustomisedSPCityToPriceMapping;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getCalendar(payload, onResponse, onError) {
    let url = APIConfig.myPlan.serviceProvider.getCalendar;
    return this.apiService.post(url, payload, onResponse, onError);
  }
  getVisionServiceProviders(onResponse, onError) {
    let url = APIConfig.myPlan.vision.getVisionServiceProviders;
    return this.apiService.get(url, onResponse, onError);
  }
  getVisionBenefits(onResponse, onError) {
    let url = APIConfig.myPlan.vision.getVisionBenefits;
    return this.apiService.get(url, onResponse, onError);
  }

  getServiceTypesForWallet(onResponse, onError) {
    let url = APIConfig.myPlan.plan.getServiceTypesForWallet;
    // onResponse([
    //   {
    //     id: 1,
    //     name: "Consultation",
    //     isActive: true,
    //     createdAt: "2025-06-19T07:19:13.155Z",
    //     updatedAt: "2025-06-19T07:20:59.936Z",
    //   },
    //   {
    //     id: 2,
    //     name: "Health Checkup",
    //     isActive: true,
    //     createdAt: "2025-06-19T07:19:13.155Z",
    //     updatedAt: "2025-06-19T07:20:59.936Z",
    //   },
    //   {
    //     id: 3,
    //     name: "Pharmacy",
    //     isActive: true,
    //     createdAt: "2025-06-19T07:19:13.155Z",
    //     updatedAt: "2025-06-19T07:20:59.936Z",
    //   },
    //   {
    //     id: 4,
    //     name: "Eye checkup",
    //     isActive: true,
    //     createdAt: "2025-06-19T07:19:13.155Z",
    //     updatedAt: "2025-06-19T07:20:59.936Z",
    //   },
    //   {
    //     id: 5,
    //     name: "Gym membership",
    //     isActive: true,
    //     createdAt: "2025-06-19T07:19:13.155Z",
    //     updatedAt: "2025-06-19T07:20:59.936Z",
    //   },
    //   {
    //     id: 6,
    //     name: "Vaccine",
    //     isActive: true,
    //     createdAt: "2025-06-19T07:19:13.155Z",
    //     updatedAt: "2025-06-19T07:20:59.936Z",
    //   },
    //   {
    //     id: 7,
    //     name: "Dental checkup",
    //     isActive: true,
    //     createdAt: "2025-06-19T07:19:13.155Z",
    //     updatedAt: "2025-06-19T07:20:59.936Z",
    //   },
    //   {
    //     id: 8,
    //     name: "Avail care",
    //     isActive: true,
    //     createdAt: "2025-06-19T07:19:13.155Z",
    //     updatedAt: "2025-06-19T07:20:59.936Z",
    //   },
    // ]);
    return this.apiService.get(url, onResponse, onError);
  }

  updateServiceCategory(id, body, onResponse, onError) {
    let url = APIConfig.myPlan.plan.updateServiceCategory.format(id);
    return this.apiService.put(url, body, onResponse, onError);
  }
}

export default PlansUtils;
